import { toUserMessage } from 'utils/apiErrorHelper';
import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import { IDownloadQueueFilterParams, IDownloadQueueItemProps } from './types';

const ENDPOINT = '/v1/download-queue';

const formatApiError = (error: any): Error => new Error(toUserMessage(error));

export const getDownloadQueueAsync = async (
  pagination: IPaginationParams,
  filter: IDownloadQueueFilterParams,
): Promise<IDownloadQueueItemProps[]> => {
  try {
    const response = await api.get(ENDPOINT, { params: { ...pagination, ...filter } });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const getDownloadQueueCountAsync = async (
  filter: IDownloadQueueFilterParams,
): Promise<number> => {
  try {
    const response = await api.get(`${ENDPOINT}/count`, { params: filter });
    return response.data;
  } catch (error) {
    throw formatApiError(error);
  }
};

export const retryDownloadQueueItemAsync = async (id: number): Promise<void> => {
  try {
    await api.post(`${ENDPOINT}/${id}/retry`);
  } catch (error) {
    throw formatApiError(error);
  }
};
